const guideRoutes = [
  {
    path: "guide",
    meta: {
      title: "가이드",
      titleEn: "Guide",
    },
    children: [
      {
        path: "index", // guide/index
        meta: {
          title: "조회 화면",
          titleEn: "Search Screen",
          isDynamic: true,
          menuCd: "GUIDE",
        },
        component: () => import("@/guide/guideAll/GuideIndex.vue"),
      },
      {
        path: "index1", // guide/index1
        meta: {
          title: "조회 화면 ver.1",
          titleEn: "Search Screen ver.1",
          isDynamic: true,
          menuCd: "GUIDE",
        },
        component: () => import("@/guide/guideVer1/GuideIndexVer1.vue"),
      },
      {
        path: "index2",
        meta: {
          title: "조회 화면 ver.2",
          titleEn: "Search Screen ver.2",
        },
        children: [
          {
            path: "", // guide/index2
            meta: {
              title: "조회 화면 ver.2",
              isDynamic: true,
            },
            component: () => import("@/guide/guideVer2/GuideIndexVer2.vue"),
          },
          {
            path: "detail2", // guide/index2/detail
            meta: {
              title: "저장 화면 ver.2",
              isDynamic: true,
            },
            component: () => import("@/guide/guideVer2/GuideDetailVer2.vue"),
          },
        ],
      },
      {
        path: "detail", // guide/detail
        meta: {
          title: "저장 화면",
          titleEn: "Save Screen",
          isDynamic: true,
        },
        component: () => import("@/guide/guideAll/GuideDetail.vue"),
      },
    ],
  },
];
export default guideRoutes;
